import './LastOne.css'

function LastOne(){
    return(
        <div className="block_end">
            <p>Copyright 2022 - Designed & Developed by Frenify</p>
        </div>
    );
}

export default LastOne;